<template>
  <div class="integration-action-table-cell">
    <div class='integration-action-table-cell__btn' @click="editIntegrationConfig" @mouseenter='editMouseEnter'>
      <lottie-animation
        class='edit-animation'
        ref="editAnimation"
        :loop='true'
        :animationData="require('@/assets/icons/animations/edit.json')"
        @loopComplete="editLoopComplete"
      />
    </div>
    <div class='integration-action-table-cell__delete-btn' @click="deleteIntegration" @mouseenter='deleteMouseEnter'>
      <lottie-animation
        class='delete-animation'
        ref="deleteAnimation"
        :loop='true'
        :animationData="require('@/assets/icons/animations/delete.json')"
        @loopComplete="deleteLoopComplete"
      />
    </div>
  </div>
</template>

<script>
import editIcon from '@/assets/icons/pencil_icon@1x.svg';
import LottieAnimation from 'lottie-web-vue';

export default {
  name: 'IntegrationActionTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
    clickEditEventName: {
      type: String,
      required: false,
      default: 'editIntegrationConfig',
    },
    clickDeleteEventName: {
      type: String,
      required: false,
      default: 'deleteIntegration',
    },
  },
  components: {
    LottieAnimation,
  },
  computed: {
    editIcon() {
      return editIcon;
    },
  },
  methods: {
    async deleteIntegration() {
      await this.$emit(this.clickDeleteEventName, this.item);
    },
    async editIntegrationConfig() {
      await this.$emit(this.clickEditEventName, this.item);
    },
    editMouseEnter() {
      this.$refs.editAnimation.play();
    },
    editLoopComplete() {
      this.$refs.editAnimation.pause();
    },
    deleteMouseEnter() {
      this.$refs.deleteAnimation.play();
    },
    deleteLoopComplete() {
      this.$refs.deleteAnimation.pause();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/styles/variables";

.integration-action-table-cell {
  align-items: center;
  justify-content: flex-end;
  display: var(--displayactioncell) !important;

  .edit {
    align-items: center;
    background-color: #EDF5FD;
    border-radius: 2px;
    cursor: pointer;
    display: flex;
    height: 28px;
    justify-content: center;
    width: 28px;
  }
  &__btn, &__delete-btn {
    z-index: 10;
    align-items: center;
    background-color: $good-button-background-color;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    height: 32px;
    justify-content: center;
    width: 32px;
    min-width: 32px;
    min-height: 32px;
    color: $default-fill-color !important;
    &:hover {
      cursor: pointer;
      border: $good-button-hover-border;
      background-color: $good-button-hover-background-color !important;
    }
    &:active{
      border: $good-button-active-border;
      background-color: $good-button-hover-background-color !important;
    }
    .edit-animation, .delete-animation{
      height: 30px;
      margin-top: -5px;
    }
  }
  &__delete-btn {
    margin-left: 15px;
    background-color: $action-button-background-color;
    &:hover {
      cursor: pointer;
      border: $action-button-hover-border;
      background-color: $action-button-hover-background-color !important;
    }
    &:active{
      border: $action-button-active-border;
      background-color: $action-button-hover-background-color !important;
    }
  }
}
</style>
